import { gql } from '@apollo/client';

const eventAssignmentsFragment = gql`
  fragment EventAssignmentsFields on EventAssignmentInfo {
    Appraiser {
      ExternalUserId
      Name
      CurrentRoleName
      WillingToTravelToAfrica
      WillingToTravelToAsia
      WillingToTravelToAustralia
      WillingToTravelToEurope
      WillingToTravelToNorthAmerica
      WillingToTravelToSouthAmerica
      WillingToTravelToVirtual
    }
    EventAppraiserAssignment {
      Id
      Rank
      ActiveRole
      ActiveStatus
    }
    EventBid {
      Id
      BidDate
    }
    NumOfEventsBeforeAfter
    Type
    TeamRole
    AssignmentCurrentRole
    AssignmentCurrentRoleName
    CanBeObserved
    CanObserve
    IsUnavailableAfterDCR
    CurrentUserAssignmentPermissions {
      CanEditRole
      CanEditRank
    }
  }
`;

export default eventAssignmentsFragment;
